// @ts-nocheck
/* eslint-disable */
import { node } from "~/util/dom";
import Content from './content';
import { _ } from "~/i18n";

/**
 * @class Vytváří položku obsahu vizitky - parkoviste s obsazenosti
 * @private
 */
 export default class Parking extends Content {
	_build() {
		if (this._data.nodeType) {
			return
		}

		this._dom.container.classList.add("content-parking");

		// kryte a hlidane
		if (this._data.sheltered || this._data.supervised) {
			var nodes = [];
			if (this._data.sheltered) { nodes.push(_("detail.content.parking.sheltered")); }
			if (this._data.supervised) { nodes.push(_("detail.content.parking.supervised")); }

			this._dom.container.appendChild(node("p", { innerHTML: _("detail.content.parking.parkingIs") + " " + nodes.join(" " + _("detail.content.parking.and") + " ") + "." }));
		}

		// kapacita
		if (typeof this._data.capacity === "number" || typeof this._data.free === "number") {
			var rows = [];
			if (this._data.free) { rows.push('<tr class="free"><td>' + _("detail.content.parking.free") + '</td><td class="last"><strong>' + this._data.free + "</strong></td></tr>"); }
			if (this._data.capacity) { rows.push('<tr><td>' + _("detail.content.parking.total") + '</td><td class="last">' + this._data.capacity + "</td></tr>"); }

			this._dom.container.insertAdjacentHTML("beforeend", '<h3>' + _("detail.content.parking.capacity") + '</h3><div class="table-container"><table>' + rows.join("") + "</table></div>");
		}
		else if (typeof this._data.capacity === "object" || typeof this._data.free === "object") {
			var rows = [];
			if (this._data.free) { rows.push('<tr class="free"><td>' + this._data.free.label + '</td><td class="last"><strong>' + this._data.free.value + "</strong></td></tr>"); }
			if (this._data.capacity) { rows.push('<tr><td>' + this._data.capacity.label + '</td><td class="last">' + this._data.capacity.value + "</td></tr>"); }

			this._dom.container.insertAdjacentHTML("beforeend", '<h3>' + (this._data.label ? this._data.label : _("detail.content.parking.capacity")) + '</h3><div class="table-container"><table>' + rows.join("") + "</table></div>");
		}
	}
}
